const MOBILE_FILTERS_PANEL_ID = 'mobile-filters-panel'

export { MOBILE_FILTERS_PANEL_ID }
